import { useMemo } from 'react';
import { useProjectContext } from '../providers/ProjectProvider';
import { IPhase, PhaseType } from '../types';

export const useProject = () => {
  const context = useProjectContext();
  const phases: IPhase[] = context.project?.phases || [];

  const activePhaseId: string | null = useMemo(
    () => context.activePhase?.id || null,
    [context.activePhase]
  );

  const activePhaseType: PhaseType | null = useMemo(
    () => context.activePhase?.type || null,
    [context.activePhase]
  );

  return {
    ...context,
    phases,
    activePhaseId,
    activePhaseType,
  };
};
